

// var debug = require("../support/debug.js");
var woxin = require("../support/woxin.js");
var window = require("../support/window.js");
var escape = require("../support/escape.js");
var logger = require("../support/logger.js");
var debug = require("../support/debug.js");
var browser = require("./browser.js");


var debug_userPhone = "woxinSupport_userPhone";
var debug_userLevel = "woxinSupport_userLevel";
var debug_cityCode = "woxinSupport_cityCode";
var debug_share = "woxinSupport_share";
var debug_pay = "woxinSupport_pay";
var debug_local = "woxinSupport_userLocal";
var debug_appInfo = "woxinSupport_appInfo";



// 获取用户信息的IOS支持
//		> 相关方法必须在top页面引入tellhowdm.js
//		> 页面ready后，延迟一段时间再调用相关方法
window.top._jxsm_ios_info_cache = {
		phoneNO : undefined,
		cityCode : undefined,
		userName : undefined,
		token : undefined,
		inLevel : undefined,
		version : -1
};
if (browser.versions.ios) {
	window.openhtmlgetStars = function(phoneNO,cityCode,userName,token,inLevel) {
		window.top._jxsm_ios_info_cache.phoneNO = phoneNO;
		window.top._jxsm_ios_info_cache.cityCode = cityCode;
		window.top._jxsm_ios_info_cache.userName = userName;
		window.top._jxsm_ios_info_cache.token = token;
		window.top._jxsm_ios_info_cache.inLevel = inLevel;
	}
	window.getVersionCode = function(version) {
		window.top._jxsm_ios_info_cache.version = version;
	}
}


/**
	url：分享的链接，如无则传空
    titel：链接名称，如无则传空
    text：描述（分享时的内容,如为短信则传要发送的内容）
    logoUrl：微信上看到的小图片（最好不要超过10K，否则有可能分享不了），短信传空
    mobile：短信分享对方号码，如无则传空
 */
var share = function(url, title, text, logoUrl, mobile) {
	if (debug(debug_share)) {
		alert("woxin分享接口调用\n\nurl : "+url+"\ntitle : "+title+"\ntext : "+text+"\nlogoUrl : "+logoUrl+"\nmobile : "+mobile+"");
		return;
	}
	if (browser.versions.android) {
		woxin.share(url, title, text, logoUrl, mobile);
		
	} else if (browser.versions.ios) {
		var shareurl = "shangmeng://woxin.com/woxinshare1234567890"+ url + "1234567890" + escape.EncodeUtf8(title) + "1234567890" 
			+ escape.EncodeUtf8(text) + "1234567890" + logoUrl + "1234567890" + mobile;
		document.location = shareurl;
		
	} else {
		logger("未知浏览器类型，不能调用woxin分享接口");
		
	}
};


/**
 * 获取编译版本
 */
var buildVersion = function(callback) {
	if (browser.versions.android) {
		if (!woxin.getVersonCode) {
			callback(-1);	// < 130
		} else {
			callback(woxin.getVersonCode());
		}
		
	} else if (browser.versions.ios) {
		window.setTimeout(function() {
			callback(window.top._jxsm_ios_info_cache.version);
		}, 100);
	}
};


/**
 * 是否支持支付宝
 */
var isSupportAlipay = function(callback) {
	buildVersion(function(version) {
		if (browser.versions.android) {
			callback(version >= 130)
			
		} else if (browser.versions.ios) {
			callback(version >= 34)
			
		}
	});
};


/**
 * 调用支付
 * @sessionId 
 * @callback 回调方法
 * @paytype alipay/hebao
 * 
 * 
 * callback(code, errmsg)
 * 
 * code : 	支付宝9000支付成功，6001用户取消
 * 			和包 0：成功 1：取消 2：失败
 * 
 */
var pay = function(sessionId, callback, paytype) {
	// 兼容旧版本接口
	if (!paytype || ["hebao", "alipay"].indexOf(paytype) == -1) {
		paytype = "hebao";
	}
	// 调用支付接口
	if (debug(debug_pay)) {
		alert("woxin支付接口调用\n\nsessionId : "+sessionId+" \n\npaytype : " + paytype + " \n\n");
		if ('hebao' == paytype) {
			window.top.successinfo();
		} else if ("alipay" == paytype) {
			window.top.alipayResult();
		}
		return;
	}
	if (browser.versions.android) {
		if ('hebao' == paytype) {
			// 注册回调通知
			window.top.successinfo = callback;
			//
            woxin.loadPayPluginNoWX(sessionId);
			/*buildVersion(function(version) {
				if (version >= 140) {
					// 新版本支付，跳转到和包支付
					woxin.loadMocamOpenPay(sessionId);
					
				} else {
					// 旧版本支付，和包插件式唤起
					woxin.loadPayPluginNoWX(sessionId);
					
				}
			});*/
			
		} else if ("alipay" == paytype) {
			window.alipayResult = callback;
			window.top.alipayResult = callback;
			//
			woxin.callAliPay(sessionId);
			
		}
		
	} else if (browser.versions.ios) {
		if ('hebao' == paytype) {
			// 注册回调通知
			window.top.successinfo = callback;
			//
            // 旧版本支付，和包插件式唤起
            var payInUrl = "shangmeng://callPay1234567890" + sessionId;
            document.location = payInUrl;
            /*
			buildVersion(function(version) {
				if (version >= 62) {
					// 新版本支付，跳转到和包支付
					window.woxincallhebaoapppay(sessionId);
					
				} else {
					// 旧版本支付，和包插件式唤起
					var payInUrl = "shangmeng://callPay1234567890" + sessionId;
					document.location = payInUrl;
					
				}
			});
			*/
		} else if ("alipay" == paytype) {
			window.top.alipayresult = callback;
			//
			var payInUrl = "callalipay:" + sessionId;
			document.location = payInUrl;
			
		}
		
	} else {
		logger("未知浏览器类型，不能调用woxin支付接口");
		
	}
	
};


/**
 * 获取用户手机号码（明文）
 */
var userPhone = function() {
	if (debug(debug_userPhone)) {
		return debug(debug_userPhone);
	}
	if (browser.versions.android) {
		return woxin.getCellPhone();
		
	} else if (browser.versions.ios) {
		return window.top._jxsm_ios_info_cache.phoneNO;
		
	} else {
		logger("未知浏览器类型，不能调用woxin手机号码接口");
		return undefined;
		
	}
	
};


/**
 * 获取登陆信息
 */
var loginInfo = function(callback) {
	if (browser.versions.android) {
		if (callback && typeof(callback) == 'function') {
			callback({
				phone : woxin.getCellPhone(),
				token : encodeURIComponent(woxin.getAccessToken())
			});
		}
		
	} else if (browser.versions.ios) {
		window.setTimeout(function() {
			if (callback && typeof(callback) == 'function') {
				callback({
					phone : window.top._jxsm_ios_info_cache.phoneNO,
					token : encodeURIComponent(window.top._jxsm_ios_info_cache.token)
				});
			}
		}, 300);
		
	} else {
		logger("未知浏览器类型，不能调用woxin登陆信息接口");
		return undefined;
		
	}
};


/**
 * 获取用户星级
 */
var userLevel = function() {
	if (debug(debug_userLevel)) {
		return debug(debug_userLevel);
	}
	if (browser.versions.android) {
		return woxin.getUserStar();
		
	} else if (browser.versions.ios) {
		return window.top._jxsm_ios_info_cache.inLevel;
		
	} else {
		logger("未知浏览器类型，不能调用woxin用户星级接口");
		
	}
	
};


var cityCode = function() {
	var treatment = function (code) {
		if (code && code.length < 4) {
			return "0" + code;
		}
	};
	if (debug(debug_cityCode)) {
		return treatment(debug(debug_cityCode));
	}
	if (browser.versions.android) {
		return treatment(woxin.getCityCode());
		
	} else if (browser.versions.ios) {
		return treatment(window.top._jxsm_ios_info_cache.cityCode);
		
	} else {
		logger("未知浏览器类型，不能调用woxin用户地市接口");
		
	}
};


/**
 * 用户地理位置
 */
var userLocal = function() {
	if (debug(debug_local)) {
		return debug(debug_local);
	}
	if (browser.versions.android) {
		return {
			x : woxin.getLocationX(),
			y : woxin.getLocationY()
		};
	} else if (browser.versions.ios) {
		return {
			x : woxinlongitude,
			y : woxinlatitude
		};
	} else {
		logger("未知浏览器类型，不能调用woxin用户GPS接口");
	}
};


/**
 * 用户信息
 */
var appInfo = function() {
	if (debug(debug_appInfo)) {
		return debug(debug_appInfo);
	}
	var infoStr = woxin.getAppInfo();
	if (!infoStr) {
		return {};
	} else {
		// 355464060328472,3.0.4,122,WIFI
		var groups = /([^,]*),([^,]*),([^,]*),([^,]*)/ig.exec(infoStr);
		if (!groups) {
			return {};
		}
		return {
			imei : groups[1],
			version : groups[2],
			versionCode : groups[3],
			networkType : groups[4]
		}
	}
};




/**
 * 选择app通讯录
 * @num 选择数量
 * @callback 回调通知
 * 		resultCode 状态码，0成功
 * 		resultMsg 错误消息
 * 		list 选择列表
 * 		orimsg 原始对象
 */
var selectPhone = function(num, callback) {
	// 注册回调通知
	var result = function(resultCode, resultMsg, tel, name) {
		// 成功： resultCode == "0"
		var list = [];
		var telArray = tel.split("|");
		for (var i=0; i<telArray.length; i++) {
			list.push({
				name : name.split("|")[i],
				tel : telArray[i]
			})
		}
		if (callback && typeof(callback) == 'function') {
			callback(resultCode, resultMsg, list, {
				resultCode : resultCode,
				resultMsg : resultMsg,
				tel : tel,
				name : name
			});
		}
	};
	window.top.getmultiphonedirectoryresult = result;
	window.top.getphonedirectoryresult1 = result;
	// 调用
	if (browser.versions.android) {
		woxin.getMutiphonedirectory(num)
		
	} else if (browser.versions.ios) {
		var spInUrl = "shangmeng://getMutiphonedirectory1234567890" + num;
		document.location = spInUrl;
		
	} else {
		logger("未知浏览器类型，不能调用woxin通讯录选择接口");
		
	}
	
};


/**
 * 选择系统通讯录
 * @callback 回调通知
 * 		resultCode 状态码，0成功
 * 		resultMsg 错误消息
 * 		list 选择列表
 * 		orimsg 原始对象
 */
var selectPhoneBySys = function(callback) {
	// 注册IOS回调通知
	var resultIOS = function(name, tel) {
		if (callback && typeof(callback) == 'function') {
			callback("0", "默认", tel,name);
		}
	};
	// 注册Android回调通知
	var resultAndroid = function(errcode, errmsg, name, phone) {
		// 成功： resultCode == "0"
		if (callback && typeof(callback) == 'function') {
			callback(errcode, errmsg, phone.replace(/\s+/g,""),name);
		}
	};
	window.top.systemContactResult = resultIOS;
	window.top.getphonedirectoryresult = resultAndroid;
	// 调用
	if (browser.versions.android) {
		window.woxin.selectSystemContact();
	} else if (browser.versions.ios) {
		woxinIosMethodWithArgs('chooseSystemContactPeople');
	} else {
		logger("未知浏览器类型，不调用通讯录选择接口");
	}
	
};

/**
 * 是否支持选择系统通讯录
 */
var isSupportSelectPhoneBySys = function(callback) {
	buildVersion(function(version) {
		if (browser.versions.android) {
			callback(version >= 139)
			
		} else if (browser.versions.ios) {
			callback(version >= 62)
			
		}
	});
};
/**
 * 设置title
 */
var setTitle = function(title) {
	if (browser.versions.android) {
		window.woxin.wxSetTitle(title);
	} else if (browser.versions.ios) {
		wxSetTitle(title);
	}
};
try{
	if (browser.versions.android||browser.versions.ios) {
		setTitle(document.title);
	}
}catch (e) {
	console.log("init[setTitle]exception");
}
/**
 * 是否支持IM
 */
var isSupportWxChat = function(callback) {
    buildVersion(function(version) {
        if (browser.versions.android) {
            callback(version >= 140)

        } else if (browser.versions.ios) {
            callback(version > 62)
        }
    });
};
var wxChat = function (phone,callback) {
    if (browser.versions.android) {
        window.woxin.wxChatWithFriend('sm',phone);
    } else if (browser.versions.ios) {
        window.wxChatWithFriend('sm',phone);
    } else {
        logger("未知浏览器类型，不调用chat接口");
    }
}
/**
 * 调用JS方法  控制顶部导航栏
 * type :1 为文字按钮    2为图片按钮     如果为2   第二个参数为图片路径
 */
var setRightButton = function(type,text) {
    if (browser.versions.android) {
        window.woxin.smsetrightbutton(type,text);
    } else if (browser.versions.ios) {
        window.smsetrightbutton(type,text);
    }
};
try{
    if (browser.versions.android||browser.versions.ios) {
        setRightButton(1,"");
    }
}catch (e) {
    console.log("init[setRightButton]exception");
}

/**
 * 调用JS方法  控制顶部导航栏
 * type :1 为文字按钮    2为图片按钮     如果为2   第二个参数为图片路径
 */
var getContactJsonString = function(type,text) {
    if (browser.versions.android) {
        window.woxin.getContactJsonStringMethod();
    } else if (browser.versions.ios) {
        window.smsetrightbutton(type,text);
    }
};
/**
 * 调用JS方法  获取通讯录全量数据，以json形式返回
 */
var getContactJsonString = function(callback) {

    // 注册回调通知
    var result = function(jsonstring) {
        if (callback && typeof(callback) == 'function') {
            if (browser.versions.android) {
                callback(JSON.stringify(jsonstring));
            } else if (browser.versions.ios) {
                callback(jsonstring);
            }
        }
    };

    window.top.getAllContactString = result;
    // 调用
    if (browser.versions.android) {
        window.woxin.getContactJsonStringMethod();
    } else if (browser.versions.ios) {
        requestContactJsonString();
    } else {
        logger("未知浏览器类型");
    }

};
/**
 * 我信js支持方法
 */
module.exports = {
		share : share,
		pay : pay,
		userPhone : userPhone,
		userLevel : userLevel,
		userLocal : userLocal,
		cityCode : cityCode,
		appInfo : appInfo,
		selectPhone : selectPhone,
		selectPhoneBySys : selectPhoneBySys,
		buildVersion : buildVersion,
		isSupportAlipay : isSupportAlipay,
		loginInfo : loginInfo,
		isSupportSelectPhoneBySys : isSupportSelectPhoneBySys,
		setTitle : setTitle,
    	isSupportWxChat : isSupportWxChat,
    	wxChat : wxChat,
    	setRightButton : setRightButton,
    	getContactJsonString : getContactJsonString
}













//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/func/woxinSupport.js
// module id = 9
// module chunks = 0